export const theme = {
  colors: {
    primary: '#e2452a',
    secondary: '#64748b',
    background: '#ffffff',
    surface: '#f8fafc',
    text: '#1e293b',
    textSecondary: '#64748b',
    border: '#e2e8f0',
    success: '#22c55e',
    error: '#ef4444',
    accent: '#e2452a'
  },

  spacing: {
    xxs: 2,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48
  },

  typography: {
    h1: {
      fontSize: 28,
      fontWeight: 'bold',
      lineHeight: 40
    },
    h2: {
      fontSize: 24,
      fontWeight: 'bold',
      lineHeight: 32
    },
    h3: {
      fontSize: 20,
      fontWeight: '600',
      lineHeight: 28
    },
    body: {
      fontSize: 16,
      fontWeight: 'normal',
      lineHeight: 24
    },
    small: {
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: 20
    },
    caption: {
      fontSize: 12,
      fontWeight: 'normal',
      lineHeight: 16
    }
  },

  borderRadius: {
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16
  },

  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.15)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.2)'
  }
};

